import type { LucideProps } from 'lucide-react'

export const Close = (props: LucideProps) => {
	return (
		<svg
			width="20"
			height="20"
			viewBox="0 0 20 20"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<title>Close</title>
			<g clipPath="url(#clip0_8602_2775)">
				<path
					d="M15.8334 5.34169L14.6584 4.16669L10.0001 8.82502L5.34175 4.16669L4.16675 5.34169L8.82508 10L4.16675 14.6584L5.34175 15.8334L10.0001 11.175L14.6584 15.8334L15.8334 14.6584L11.1751 10L15.8334 5.34169Z"
					fill="currentColor"
				/>
			</g>
			<defs>
				<clipPath id="clip0_8602_2775">
					<rect width="20" height="20" fill="white" />
				</clipPath>
			</defs>
		</svg>
	)
}
